import styled, { css } from "styled-components";
import { space, typography } from "styled-system";
import themeGet from "@styled-system/theme-get";
import { PaymentInputsWrapper as PaymentInputsWrapperComp } from "react-payment-inputs";

const wrapperStyles = (hasFormError) => ({
  fieldWrapper: {
    base: css`
      width: 100%;
    `,
    errored: css`
      margin-bottom: 8px;
    `,
  },
  inputWrapper: {
    base: css`
      height: 35px;
      padding: 6px 12px;
      font-size: 14px;
      line-height: 1.5;
      font-weight: 400;
      color: ${themeGet("colors.input.color", "#768192")};
      background-color: ${themeGet("colors.input.background", "#fff")};
      border: 1px solid ${themeGet("colors.input.borderColor", "#d8dbe0")};
      border-radius: 4px;
      margin-bottom: 16px;
      transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
      box-shadow: none;
    `,
    focused: css`
      color: ${themeGet("colors.input.focus.color", "#768192")};
      background-color: ${themeGet("colors.input.focus.backgroundColor", "#fff")};
      outline: 0 !important;
      border-color: ${themeGet("colors.input.focus.borderColor", "#1b4aa8")};
      box-shadow: 0 0 0 3px rgb(39 93 168 / 50%);
      
      ${hasFormError && css`box-shadow: 0 0 0 3px rgb(229 83 83 / 25%);`}

      input[type="tel"] {
        ${themeGet("colors.input.focus.backgroundColor", "#fff")};
      }
    `,
    errored: css`
      border-color: ${themeGet("colors.input.invalid.borderColor", "#d93737")} !important;
      box-shadow: none;
      margin-bottom: 5px;
    `,
  },
  input: {
    base: css`
      background-color: ${themeGet("colors.input.focus.backgroundColor", "#fff")};
      color: ${themeGet("colors.input.focus.color", "#768192")};
      font-weight: 400;

      // Placeholder
      &::placeholder {
        color: ${themeGet("colors.input.placeholder.color", "#8a93a2")};
        opacity: 1;
      }
    `,
    cardNumber: css`
      width: 200px;
    `,
    expiryDate: css`
      width: 80px;
    `,
    cvc: css`
      width: 50px;
    `,
  },
  errorText: {
    base: css`
      width: 100%;
      margin-top: 2.5px;
      font-size: 80%;
      color: #dc3545;
    `,
  },
});

const PaymentInputsWrapper = styled(PaymentInputsWrapperComp)`
  ${({ hasError, hasFormError, ...props }) => (hasError || hasFormError) && css`
    div:first-child {
      padding-right: calc(1.5em + 7.5px);
      background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='${encodeURIComponent(themeGet("colors.input.invalid.borderColor", "#d93737")(props))}' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='${encodeURIComponent(themeGet("colors.input.invalid.borderColor", "#d93737")(props))}' stroke='none'/%3e%3c/svg%3e");
      background-repeat: no-repeat;
      background-position: right calc(0.375em + 1.875px) center;
      background-size: calc(0.75em + 3.75px) calc(0.75em + 3.75px);
      transition: none;
    }
  `}

  ${({ hasFormError }) => hasFormError && css`
    div:first-child {
      border-color: ${themeGet("colors.input.invalid.borderColor", "#d93737")} !important;
      box-shadow: none;
      margin-bottom: 5px;
    }
  `}
`;

const PaymentInputContainer = styled.div`
  /* Style system support */
  ${space}
  ${typography}
`;

export {
  PaymentInputContainer,
  PaymentInputsWrapper,
  wrapperStyles
};
